import React from "react";
// Customizable Area Start
import EarningsController, { Props } from "./EarningsController.web";
import NavigationMenu from "../../navigationmenu/src/NavigationMenu.web";
import { Box, createStyles, IconButton, LinearProgress, Typography, withStyles } from "@material-ui/core";
import { blackFilterIcon, whiteFilterIcon } from "../../advancedsearch/src/assets";
import moment from "moment";
import { infoOutlinedIcon, nextIconBlack, nextIconWhite } from "./assets";
import RightSideBar from "../../activityfeed/src/RightSideBar.web";

// Customizable Area End

export default class Earnings extends EarningsController {
    constructor(props: Props) {
        super(props);
        // Customizable Area Start
        // Customizable Area End
    }
    // Customizable Area Start

    // Customizable Area End

    render() {
        // Customizable Area Start
        const { classes, checked, navigation } = this.props
        return (
            <NavigationMenu id="" tabItem="Earnings" checked={checked} navigation={navigation}>
                <Box className={classes.wrapper}>
                    <Box className={classes.rightPane}>
                        <Box className={classes.headerRow}>
                            <Typography className={classes.titleText}>Your Arrows Earnings</Typography>
                            <IconButton>
                                <img src={checked ? blackFilterIcon : whiteFilterIcon} alt="search-location" />
                            </IconButton>
                        </Box>

                        <Box className={classes.paymentCard}>
                            <Typography className={classes.paymentSentText}>Your payment was sent</Typography>
                            <Typography className={classes.amoutText}>$ {parseFloat(this.state.total_earning.toString()).toFixed(2)}</Typography>
                        </Box>

                        <Box style={{ paddingLeft: '20px' }}>
                            <Typography className={classes.monthEarningText}>{moment().format("MMM")} Earnings</Typography>

                            <Typography className={classes.amoutText}>${parseFloat(this.state.current_month_earning.toString()).toFixed(2)}</Typography>
                            <LinearProgress
                                variant="determinate"
                                value={this.state.progressPercentage}
                                className={checked ? classes.progressBarLightStyle : classes.progressBarDarkStyle}
                            />

                            <Box style={{ display: 'flex', flexDirection: "row", alignItems: 'center', justifyContent: 'space-between' }}>
                                <Typography className={classes.monthEarningText}>Payment minimum: $ {parseFloat(this.state.minimum_payment.toString()).toFixed(2)}</Typography>

                                <IconButton>
                                    <img src={infoOutlinedIcon} className={classes.icon} />
                                </IconButton>
                            </Box>
                        </Box>

                        <Box
                            className={classes.buttonContainer}
                            onClick={() => this.navigationHandler('Payment Activity')}
                            data-test-id="payment-activity"
                        >
                            <Typography className={classes.buttonText}>View Payment Activity</Typography>
                        </Box>

                        <Typography className={classes.titleText}>Your Arrows Earnings</Typography>
                        <Box data-test-id="earning-options">
                            {this.earningsOptionsList.map((item, index) => {
                                return (
                                    <Box
                                        key={index}
                                        className={classes.optionRow}
                                        onClick={() => this.navigationHandler(item.label)}
                                    >
                                        <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', }}>
                                            <img src={item.icon} className={classes.icon} style={{ padding: '12px' }} />
                                            <Typography className={classes.optionRowText} style={{ color: checked ? "#222222" : "#FFFFFF" }}>
                                                {item.label}
                                            </Typography>
                                        </Box>
                                        <img
                                            src={checked ? nextIconBlack : nextIconWhite}
                                            className={classes.icon}
                                            style={{ padding: '12px' }}
                                        />
                                    </Box>
                                )
                            })}
                        </Box>
                    </Box>

                    <RightSideBar checked={checked} navigation={navigation} />
                </Box>
            </NavigationMenu>
        );
        // Customizable Area End
    }
}

// Customizable Area Start

const style = createStyles({
    wrapper: {
        width: "100%",
        display: "flex",
    },
    rightPane: {
        display: "flex",
        flexDirection: "column",
        padding: '24px',
        width: '60%',
        "@media (max-width:1000px)": {
            width: "80%",
        },
    },
    headerRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '37px',
    },
    titleText: {
        fontSize: '24px',
        lineHeight: '48px',
        fontWeight: 800,
        fontFamily: 'Manrope',
        background: "linear-gradient(330.07deg, #3858E3 -51.03%, #BA05F7 138.78%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
    },
    paymentCard: {
        display: 'flex',
        flexDirection: 'column',
        padding: '20px',
        borderRadius: '10px',
        background: "linear-gradient(357.07deg, #3858E3 -51.03%, #BA05F7 138.78%)",
        marginBottom: '15px'
    },
    paymentSentText: {
        fontSize: '18px',
        lineHeight: '24px',
        fontWeight: 800,
        fontFamily: 'Manrope',
        color: '#fff',
        marginBottom: '15px',
    },
    amoutText: {
        fontSize: '24px',
        lineHeight: '27px',
        fontWeight: 800,
        fontFamily: 'Manrope',
        color: '#fff',

    },
    monthEarningText: {
        fontSize: '18px',
        lineHeight: '26px',
        fontWeight: 500,
        fontFamily: 'Manrope',
        color: '#6B6B6B',
        marginBottom: '15px',
    },
    progressBarDarkStyle: {
        height: '8px',
        borderRadius: '10px',
        backgroundColor: '#222222',
        marginTop: '10px',
        marginBottom: '15px',
        '& .MuiLinearProgress-bar': {
            borderRadius: '10px',
            background: "linear-gradient(330.07deg, #3858E3 -51.03%, #BA05F7 138.78%)",
        },
    },
    progressBarLightStyle: {
        height: '8px',
        borderRadius: '10px',
        backgroundColor: '#E9E9E9',
        marginTop: '10px',
        marginBottom: '15px',
        '& .MuiLinearProgress-bar': {
            borderRadius: '10px',
            background: "linear-gradient(330.07deg, #3858E3 -51.03%, #BA05F7 138.78%)",
        },
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'column',
        padding: '12px',
        borderRadius: '10px',
        background: "linear-gradient(357.07deg, #3858E3 -51.03%, #BA05F7 138.78%)",
        marginTop: '10px',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '28px',
    },
    buttonText: {
        fontSize: '14px',
        lineHeight: '22px',
        fontWeight: 500,
        fontFamily: 'Manrope',
        color: '#fff',
    },
    icon: {
        width: '24px',
        height: '24px',
    },
    optionRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '5px',
        cursor: 'pointer',
    },
    optionRowText: {
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: 400,
        fontFamily: 'Inter',
        cursor: 'pointer',
    },
});

export const EarningsScreen = withStyles(style)(Earnings);
// Customizable Area End
